import { useToastedMutation } from '@fv/client-components'
import { useQueryClient } from '@fv/client-core'
import type { LoadTemplateDTO, UpsertLoadTemplateDTO } from '@fv/models'

import { shipperFetch } from '@/utils/shipperFetch'

import { loadTemplateKeys } from './queries'

const upsertLoadTemplate = (id?: string) => (body: UpsertLoadTemplateDTO) =>
  shipperFetch<LoadTemplateDTO>(`/load-templates${id ? `/${id}` : ''}`, {
    body,
    method: id ? 'PUT' : 'POST',
  })

export const useUpsertLoadTemplate = (id?: string) => {
  const queryClient = useQueryClient()
  return useToastedMutation(upsertLoadTemplate(id), {
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: loadTemplateKeys.all })
    },
    toastErrorPrefix: () => 'Error saving shipment template',
    toastSuccess: () => 'Shipment template saved successfully',
  })
}

const deleteLoadTemplate = (id: string) =>
  shipperFetch(`/load-templates/${id}`, {
    method: 'DELETE',
  })

export const useDeleteLoadTemplate = () => {
  const queryClient = useQueryClient()
  return useToastedMutation(deleteLoadTemplate, {
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: loadTemplateKeys.all })
    },
    toastErrorPrefix: () => 'Error removing shipment template',
    toastSuccess: () => 'Shipment template removed successfully',
  })
}
